// extracted by mini-css-extract-plugin
module.exports = {"documentsContainer":"Documentation_documentsContainer__NbZjS"};